export default __webpack_public_path__ + "static/media/avatar_blue.628fac50.svg";